import axiosInstance from './axios.instance';

// How often to silently probe the session while the tab is idle.
const POLL_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

// Lightweight authenticated request — any 401 is caught by attachAuthInterceptors
// which clears localStorage and redirects to '/'. Non-auth errors are swallowed.
// `abortOnNavigate: false` because this poll belongs to the tab, not to any
// page — a navigation must not cancel a session probe that is mid-flight.
const probe = () =>
  axiosInstance.get('/me', { abortOnNavigate: false }).catch(() => {});

export const installSessionGuard = () => {
  // Catches users who leave the dashboard open and walk away.
  setInterval(probe, POLL_INTERVAL_MS);

  // Catches users who return to the tab after a long absence.
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') probe();
  });

  // If another tab logs out (clears localStorage.auth), redirect here too.
  // Note: 'storage' events only fire in tabs *other* than the one that wrote.
  window.addEventListener('storage', (e) => {
    if (e.key === 'auth' && !e.newValue) {
      window.location.replace('/');
    }
  });
};

export default installSessionGuard;
